import { render } from "./ModalDocumentMove.vue?vue&type=template&id=1d5fadf8&scoped=true"
import script from "./ModalDocumentMove.vue?vue&type=script&lang=js"
export * from "./ModalDocumentMove.vue?vue&type=script&lang=js"

import "./ModalDocumentMove.vue?vue&type=style&index=0&id=1d5fadf8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d5fadf8"]])

export default __exports__